export default __webpack_public_path__ + "static/media/form.fecb13b9.svg";